/* Independent Alton Towers feed client. Two public ride providers; park schedules from ThemeParks.wiki.
   Responses are date-checked by the consuming widgets. No old Lovable project required. */
(function (w) {
  "use strict";
  if (w.UATOFeed) return;
  var parkId="0d8ea921-37b1-4a9a-b8ef-5b45afea847b";
  var base="https://api.themeparks.wiki/v1/entity/"+parkId;
  var cache={}, timeoutMs=7500;
  function request(url,headers) {
    var controller=typeof AbortController==="function"?new AbortController():null;
    var timer=controller?setTimeout(function(){controller.abort()},timeoutMs):null;
    return fetch(url,{method:"GET",mode:"cors",cache:"no-store",headers:Object.assign({Accept:"application/json"},headers||{}),signal:controller?controller.signal:undefined}).then(function(response){
      if(!response.ok)throw Error("Data source responded "+response.status);
      return response.json();
    }).finally(function(){if(timer)clearTimeout(timer)});
  }
  function cached(name,life,get) {
    var record=cache[name],now=Date.now();
    if(record && record.expires>now)return record.promise;
    var promise=Promise.resolve().then(get);
    cache[name]={promise:promise,expires:now+life};
    promise.catch(function(){if(cache[name]&&cache[name].promise===promise)delete cache[name]});
    return promise;
  }
  function acceptedSource(payload,provider) {
    if(!payload || !Array.isArray(payload.lands))throw Error(provider+" gave no lands");
    var total=0,latest=0;
    payload.lands.forEach(function(land){
      (Array.isArray(land.rides)?land.rides:[]).forEach(function(ride){
        if(!ride||typeof ride.name!=="string")return;
        total++;
        var date=Date.parse(ride.last_updated||"");
        if(Number.isFinite(date))latest=Math.max(latest,date);
      });
    });
    if(total<2)throw Error(provider+" gave no rides");
    return {data:payload,latest:latest,total:total,provider:provider};
  }
  function wikiQueues(response) {
    var items=Array.isArray(response?.liveData)?response.liveData:[];
    if(!items.length)throw Error("ThemeParks.wiki reported no attractions");
    var rides=items.filter(function(x){return x&&x.entityType==="ATTRACTION"&&typeof x.name==="string"}).map(function(x){
      var wait=x.queue?.STANDBY?.waitTime;
      return {
        id:x.id,name:x.name,is_open:x.status==="OPERATING",
        wait_time:typeof wait==="number"&&Number.isFinite(wait)&&wait>=0&&wait<=600?wait:null,
        last_updated:x.lastUpdated||null
      };
    });
    return {lands:[{name:"Alton Towers",rides:rides}]};
  }
  // Merge the independent reports, including the existing server-side source.
  // The server-side feed must not be skipped merely because a different
  // provider returned a response without usable wait times.
  function normalizeSource(raw) {
    var data=raw && raw.data && (Array.isArray(raw.data.lands)||Array.isArray(raw.data.rides))?raw.data:raw;
    if(!data || typeof data!=="object")return data;
    if(Array.isArray(data.lands))return data;
    if(Array.isArray(data.rides))return {lands:[{name:"Other rides",rides:data.rides}]};
    return data;
  }
  function quality(ride,when,now) {
    var age=now-when,dated=when>0&&age>=-90000;
    var recent=dated&&age<=15*60*1000;
    var older=dated&&age<=90*60*1000;
    var open=ride.is_open===true||ride.is_open==="true";
    var wait=ride.wait_time===null||ride.wait_time===undefined?NaN:Number(ride.wait_time);
    var hasWait=open&&Number.isFinite(wait)&&wait>=0&&wait<=600;
    return {recent:recent,older:older,open:open,hasWait:hasWait,
      rank:recent&&hasWait?5:recent&&!open?4:older&&hasWait?3:recent?2:older?1:0};
  }
  async function queueSnapshot(fallbackEndpoint,fallbackKey) {
    var requests=[
      {provider:"Queue-Times.com",run:function(){return request("https://queue-times.com/parks/1/queue_times.json")}},
      {provider:"ThemeParks.wiki",run:function(){return request(base+"/live").then(wikiQueues)}}
    ];
    if(fallbackEndpoint&&fallbackKey)requests.push({
      provider:"Server-side queue service",
      run:function(){return request(fallbackEndpoint,{apikey:fallbackKey,Authorization:"Bearer "+fallbackKey})}
    });
    var settled=await Promise.allSettled(requests.map(function(entry){
      return entry.run().then(function(data){return acceptedSource(normalizeSource(data),entry.provider)});
    }));
    var sources=[],failures=[];
    settled.forEach(function(result,i){
      if(result.status==="fulfilled")sources.push(result.value);
      else failures.push(requests[i].provider+": unavailable");
    });
    if(!sources.length)throw Error("No ride feed is currently reachable");
    var now=Date.now(),selected=new Map();
    var priority={"Queue-Times.com":3,"Server-side queue service":2,"ThemeParks.wiki":1};
    function rideKey(name){return String(name||"").toLowerCase().replace(/\[archived\]/g,"").replace(/[^a-z0-9]/g,"");}
    function choose(source,ride,area) {
      if(!ride||typeof ride.name!=="string")return;
      var key=rideKey(ride.name);if(!key)return;
      var parsed=Date.parse(ride.last_updated||"");
      var when=Number.isFinite(parsed)?parsed:0,metrics=quality(ride,when,now);
      var current=selected.get(key),score=priority[source.provider]||0;
      var chooseNew=!current||metrics.rank>current.rank||
        (metrics.rank===current.rank&&(
          score>current.priority && when>=current.timestamp-8*60*1000 ||
          score<current.priority && when>current.timestamp+8*60*1000 ||
          score===current.priority && when>current.timestamp));
      var conflict=false;
      if(current&&current.metrics.recent&&metrics.recent&&Math.abs(when-current.timestamp)<=5*60*1000){
        var a=current.ride,oldOpen=a.is_open===true||a.is_open==="true";
        var oldWait=a.wait_time==null?NaN:Number(a.wait_time);
        var newWait=ride.wait_time==null?NaN:Number(ride.wait_time);
        conflict=oldOpen!==metrics.open||
          (oldOpen&&metrics.open&&current.metrics.hasWait&&metrics.hasWait&&Math.abs(oldWait-newWait)>=20);
      }
      if(chooseNew) {
        selected.set(key,{
          ride:Object.assign({},ride,{_uatoSource:source.provider,_uatoConflict:conflict||(current&&current.ride._uatoConflict===true)}),
          area:String(area||"Alton Towers"),timestamp:when,metrics:metrics,
          rank:metrics.rank,priority:score
        });
      }else if(current) {
        if(conflict)current.ride._uatoConflict=true;
        if(current.area==="Alton Towers"&&area&&area!=="Alton Towers")current.area=String(area);
      }
    }
    sources.forEach(function(source){
      source.data.lands.forEach(function(land){
        (Array.isArray(land.rides)?land.rides:[]).forEach(function(ride){
          choose(source,ride,land.name);
        });
      });
      (Array.isArray(source.data.rides)?source.data.rides:[]).forEach(function(ride){
        choose(source,ride,"Other rides");
      });
    });
    if(!selected.size)throw Error("Providers returned no usable attractions");
    var areas=new Map(),recentWaits=0,olderWaits=0,latest=0;
    selected.forEach(function(entry){
      if(entry.metrics.recent&&entry.metrics.hasWait)recentWaits++;
      else if(entry.metrics.older&&entry.metrics.hasWait)olderWaits++;
      latest=Math.max(latest,entry.timestamp);
      if(!areas.has(entry.area))areas.set(entry.area,[]);
      areas.get(entry.area).push(entry.ride);
    });
    return {
      lands:Array.from(areas,function(entry){return {name:entry[0],rides:entry[1]};}),
      _uatoProvider:sources.map(function(source){return source.provider}).join(" + "),
      _uatoRecentRides:recentWaits,_uatoOlderRides:olderWaits,
      _uatoTotalRides:selected.size,_uatoLatest:latest,
      _uatoSourceHealth:requests.map(function(entry,i){
        return {source:entry.provider,ok:settled[i].status==="fulfilled"};
      }),
      _uatoFailures:failures,
      _uatoCheckedAt:new Date(now).toISOString()
    };
  }
  function queues(fallbackEndpoint,fallbackKey) {
    return cached("queues",45*1000,async function(){
      var saved=readSnapshot();if(saved)return saved;
      var snapshot=await queueSnapshot(fallbackEndpoint,fallbackKey);
      saveSnapshot(snapshot);return snapshot;
    });
  }
  function schedule() {
    return cached("schedule",5*60*1000,async function(){
      var response=await request(base+"/schedule");
      var items=Array.isArray(response?.schedule)?response.schedule:[];
      if(!Array.isArray(items)||!items.length)throw Error("No published park schedule");
      return {park:items,waterpark:null,provider:"ThemeParks.wiki",checkedAt:Date.now()};
    });
  }

  function londonDay(ms) {
    var p={};
    new Intl.DateTimeFormat("en-GB",{timeZone:"Europe/London",year:"numeric",month:"2-digit",day:"2-digit"}).formatToParts(new Date(ms)).forEach(function(v){p[v.type]=v.value});
    return p.year+"-"+p.month+"-"+p.day;
  }
  function parkState() {
    return cached("parkState",55*1000,async function(){
      var day=londonDay(Date.now()),data=await schedule(),entries=(data.park||[]).filter(function(x){return x&&x.date===day});
      var operating=entries.filter(function(x){return x.type==="OPERATING"&&Number.isFinite(Date.parse(x.openingTime))&&Number.isFinite(Date.parse(x.closingTime))});
      if(operating.length){
        var starts=operating.map(function(x){return Date.parse(x.openingTime)}),ends=operating.map(function(x){return Date.parse(x.closingTime)});
        var opening=Math.min.apply(null,starts),closing=Math.max.apply(null,ends),now=Date.now();
        return {status:now<opening||now>=closing?"closed":"open",date:day,opening:opening,closing:closing,source:"published park schedule"};
      }
      if(entries.length&&entries.every(function(x){return x.type==="CLOSED"}))return {status:"closed",date:day,source:"published park schedule"};
      return {status:"unknown",date:day,source:"schedule unavailable for today"};
    });
  }

  // Canonical ride model and identical freshness rules for every queue display.
  var recentLimit=15*60*1000, olderLimit=90*60*1000;
  function rideKey(name){return String(name||"").toLowerCase().replace(/\[archived\]/g,"").replace(/[^a-z0-9]/g,"");}
  function normaliseRides(payload){
    if(!payload||typeof payload!=="object")throw Error("Invalid ride snapshot");
    var entries=[],unique=new Map();
    if(Array.isArray(payload.lands))payload.lands.forEach(function(land){
      (Array.isArray(land.rides)?land.rides:[]).forEach(function(ride){entries.push({ride:ride,area:String(land.name||"Alton Towers")})});
    });
    if(Array.isArray(payload.rides))payload.rides.forEach(function(ride){entries.push({ride:ride,area:"Other rides"})});
    entries.forEach(function(entry){
      var r=entry.ride;if(!r||typeof r.name!=="string")return;
      var key=rideKey(r.name),value=r.wait_time==null?NaN:Number(r.wait_time),updated=Date.parse(r.last_updated||"");
      if(!key)return;
      var item={id:key,name:r.name,area:entry.area,isOpen:r.is_open===true||r.is_open==="true",
        wait:Number.isFinite(value)&&value>=0&&value<=600?Math.round(value):null,
        updated:Number.isFinite(updated)?updated:null,
        source:r._uatoSource||payload._uatoProvider||"Independent feed",
        conflict:r._uatoConflict===true};
      var existing=unique.get(key);
      if(!existing||existing.area==="Other rides"&&item.area!=="Other rides")unique.set(key,item);
    });
    return Array.from(unique.values());
  }
  function classifyRide(ride,parkClosed,now,feedError){
    now=typeof now==="number"?now:Date.now();
    if(parkClosed)return {code:"closed",label:"Closed",value:null,unit:"closed",sort:1};
    if(feedError)return {code:"unknown",label:"",value:null,unit:"",sort:3};
    var age=ride.updated===null?Infinity:now-ride.updated;
    var fresh=Number.isFinite(age)&&age>=-90000&&age<=recentLimit;
    if(!fresh||ride.conflict)return {code:"unknown",label:"",value:null,unit:"",sort:3};
    if(!ride.isOpen)return {code:"closed",label:"Closed",value:null,unit:"closed",sort:1};
    if(ride.wait!==null&&Number.isFinite(ride.wait)&&ride.wait>=0&&ride.wait<=600)
      return {code:"current",label:"",value:ride.wait,unit:"min",sort:0};
    return {code:"unknown",label:"",value:null,unit:"",sort:3};
  }
  function queueSummary(rides,parkClosed,now,feedError){
    var models=rides.map(function(ride){return classifyRide(ride,parkClosed,now,feedError);});
    return {recent:models.filter(function(x){return x.code==="current"}).length,
      earlier:0,
      open:models.filter(function(x){return x.code==="current"}).length,
      closed:models.filter(function(x){return x.code==="closed"}).length,
      unverified:models.filter(function(x){return x.code==="unknown"}).length,
      total:models.length};
  }
  // A short public-data cache keeps snapshots consistent when moving between
  // the homepage and the full queue page in the same browser tab.
  function readSnapshot(){
    try {
      var raw=w.sessionStorage&&w.sessionStorage.getItem("uato-queues-v3");
      if(!raw)return null;
      var entry=JSON.parse(raw);
      if(!entry||typeof entry.saved!=="number"||Date.now()-entry.saved>=20000||Date.now()<entry.saved)return null;
      if(!entry.data||!Array.isArray(entry.data.lands))return null;
      return entry.data;
    }catch(_){return null;}
  }
  function saveSnapshot(data){
    try{if(w.sessionStorage)w.sessionStorage.setItem("uato-queues-v3",JSON.stringify({saved:Date.now(),data:data}));}catch(_){}
  }

  w.UATOFeed={queues:queues,schedule:schedule,parkState:parkState,parkId:parkId,normaliseRides:normaliseRides,classifyRide:classifyRide,queueSummary:queueSummary};
})(window);